export default [
    {
        path: '/UstomsInspection',
        name: 'UstomsInspection',
        component: () => import('../../views/UstomsInspection/index.vue'),
        meta:{
            cheaKIslogin:true
        }
    }
]